{
  "hero": {
    "eyebrow": "Join",
    "title": "Build monitoring skills on a real campus sustainability challenge.",
    "lead": "Students across mechanical, electrical, software, and business tracks plan, design, test, document, and communicate AquaWorks together."
  },
  "paths": {
    "title": "Ways to take part",
    "items": {
      "students": {
        "title": "Join as a student",
        "body": "Contribute to Software, Electrical, Mechanical, or Business workstreams—from CAD and circuits to data visualization, procurement, and reporting."
      },
      "partners": {
        "title": "Advise or collaborate",
        "body": "Faculty, labs, and campus partners can guide methods, site feasibility, and responsible communication. We already consult Campus and Community Planning and Civil Engineering faculty."
      },
      "public": {
        "title": "Follow the build",
        "body": "Read Updates for milestone notes, explore Science for indicators and campus context, or watch for future open demos after controlled testing."
      }
    }
  },
  "contacts": {
    "title": "Primary contacts",
    "body": "Reach the project leads for team onboarding, collaboration, or questions about Phase 1.",
    "items": [
      {
        "name": "Jiaming Han",
        "role": "Project Lead · Faculty of Applied Science",
        "email": "jhan31@student.ubc.ca"
      },
      {
        "name": "Lucas Lyu",
        "role": "Co-Project Lead · Faculty of Applied Science",
        "email": "lyuchongkai@gmail.com"
      }
    ],
    "note": "Only project-lead emails are listed publicly. Phone numbers and student IDs are not published."
  }
}
